import { IsString, MaxLength } from 'class-validator';

export class ProductGroupSearchDTO {

    @IsString()
    @MaxLength(50)
    name: string;

}
